import React from 'react';
import { SalesforceAutomationSearchableSelectionTable } from '@periscopes/general/automations';
import { SfEntityAutomationType, SonarObjectChildTypeId, SonarObjectTypeId } from '@sonar-software/sonar-ts-types';

export interface EntityAutomationTabsProps {
	childType: SonarObjectChildTypeId;
	index: number;
	sonarObjectId: number;
	type: SfEntityAutomationType;
}

export const EntityAutomationTab: React.FC<EntityAutomationTabsProps> = ({ childType, index, sonarObjectId, type }) => {
	const targetUri = `v3/salesforce/entity-definitions/${sonarObjectId}/automations`;

	return <SalesforceAutomationSearchableSelectionTable
		childSonarObjectType={ childType }
		parentIndex={ index }
		parentSonarObjectType={ SonarObjectTypeId.SalesforceEntity }
		sonarObjectId={ sonarObjectId }
		type={ type }
		uri={ targetUri } />;
};
